import { OnInit, OnDestroy, Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { FlatPickrDirective } from '../../plugins/flatpickr/flatpickr.directive';
import { FlatPickrModel } from '../../plugins/flatpickr/flatpickr.model';
import { WeGoConfig } from '../../shared/config';


const moment = require("moment");

@Component({
  selector: 'wego-snail-trail-filter',
  template: require('../views/snail-trail-filter.component.html'),
  styles: [`
    .nopad-left{
      padding-left: 0px;
    } 
  `]
})
export class SnailTrailFilterComponent implements OnInit, OnDestroy {

  @ViewChild('flatPickrConfigFromDate') public flatPickrConfigFromDate: FlatPickrDirective;
  @ViewChild('flatPickrConfigToDate') public flatPickrConfigToDate: FlatPickrDirective;
  @Output('OnSearch') onSearchEvent = new EventEmitter();
  @Output('OnExportXls') onExportXls = new EventEmitter();
  @Output('OnResetData') onResetData = new EventEmitter();

  @Input('IsValidReport') isValidReport: boolean = false;

  @Input()
  set ErrorModel(errorModel: any) {
    this.errorModel = errorModel;
  }
  get ErrorModel() { return this.errorModel; }

  isBookingSearch: boolean = true;
  driverName: string;
  driverhashId: string;
  bookingRefrenceId: string;
  bookingHashId: string;
  licenceTag: string;
  vehicleHashId: string;
  startDateTime: string;
  endDateTime: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  errorModel: any;

  ngOnInit(): void {
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo.defaultDate = "23:59";
  }
  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }
  public SuccessSelectDriverModal($event: any) {
    this.driverhashId = $event.DriverHashID;
    this.driverName = $event.DriverName;
    this.OnFilterReset();
  }
  public SuccessSelectBookingModal($event: any) {
    this.bookingRefrenceId = $event.BookingReferenceId;
    this.bookingHashId = $event.BookingHashID;
    this.driverhashId = $event.DriverHashID;
    this.driverName = $event.DriverName;
    this.licenceTag = $event.LicenceTage;
    this.vehicleHashId = $event.VehicleMasterHashID;
    this.OnFilterReset();
  }
  public SuccessSelectVehicleModal($event: any) {
    this.licenceTag = $event.LicenceTage;
    this.vehicleHashId = $event.VehicleMasterHashID;
    this.OnFilterReset();
  }

  public OnFromDateChange(value: string) {
    if (value) {
      let format = 'DD-MM-YYYY HH:mm';
      let newDate = moment(value, format).toDate();
      let endDate = moment(this.endDateTime, format).toDate();
      if (endDate < newDate) {
        let endDateVal = moment(value, format).add('H', 1);
        this.flatPickrConfigToDate.ChangeValue(endDateVal.format('DD-MM-YYYY HH:mm'));
      }
      this.flatPickrConfigToDate.SetOption("minDate", newDate);
    }
    this.OnFilterReset();
  }

  public ClearDriver() {
    this.driverhashId = "";
    this.driverName = "";
    this.OnFilterReset();
  }

  public OnToDateChange() {
    this.OnFilterReset();
  }

  public OnFilterReset(){
    this.onResetData.emit();
  }

  public OnSearchChange() {
    this.bookingRefrenceId = "";
    this.bookingHashId = "";
    this.driverhashId = "";
    this.driverName = "";
    this.licenceTag = "";
    this.vehicleHashId = "";
    this.startDateTime = "";
    this.endDateTime = "";
    this.onResetData.emit();
  }

  OnSearch($event: any) {
    if (this.isBookingSearch) {
      this.onSearchEvent.emit({ reportSearchType: 'PER_BOOKING', bookingHashId: this.bookingHashId, driverHashId: "", vehicleHashId: "", startDateTime: "", endDateTime: "" });
    } else {
      this.onSearchEvent.emit({ reportSearchType: 'PER_VEHICLE', bookingHashId: "", driverHashId: this.driverhashId, vehicleHashId: this.vehicleHashId, startDateTime: this.startDateTime, endDateTime: this.endDateTime });
    }
  }

  OnExportXls($event: any) {
    if (this.isBookingSearch) {
      this.onExportXls.emit({ reportSearchType: 'PER_BOOKING', bookingHashId: this.bookingHashId, driverHashId: "", vehicleHashId: "", startDateTime: "", endDateTime: "" });
    } else {
      this.onExportXls.emit({ reportSearchType: 'PER_VEHICLE', bookingHashId: "", driverHashId: this.driverhashId, vehicleHashId: this.vehicleHashId, startDateTime: this.startDateTime, endDateTime: this.endDateTime });
    }
  }
  ngOnDestroy(): void {

  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/snail-trail/components/snail-trail-filter.component.ts